import wx from 'weixin-js-sdk'
import axios from 'axios'

export async function initWxShare(shareInfo) {
  const url = window.location.href.split('#')[0]
  console.log(url,'url')
  
  try {
    // 后端接口，换成你自己真实的
    const { data } = await axios.get('http://www.international-brands.net/index/index/wxjssdk', { params: { url: url } })
    // console.log(data.appId,'微信分享配置')
    
    const configData = data
   
    wx.config({
      debug: false,
      appId: configData.appId,
      timestamp: configData.timestamp,
      nonceStr: configData.nonceStr,
      signature: configData.signature,
      jsApiList: [
        'updateAppMessageShareData',
        'updateTimelineShareData'
      ]
    })
    

    wx.ready(() => {
      // 分享给朋友
      wx.updateAppMessageShareData(shareInfo)
      // 分享到朋友圈
      wx.updateTimelineShareData(shareInfo)
    })

    wx.error(err => console.error('微信配置失败', err))
  } catch (err) {
    console.error('获取签名失败', err)
  }
}